module.exports = __webpack_public_path__ + "img/canyon_natural_ba_detail_rsh5(1).49a3f3af.jpg";